import Vue from 'vue';

export default class AlertService {
	showAlert(modal, tipo, titulo, msg) {
		let clase = 'p-2 border-bottom-0 justify-content-center ' + tipo;
		try {
			modal.msgBoxOk(msg, {
				title: titulo,
				size: 'sm',
				buttonSize: 'sm',
				okVariant: tipo,
				/*headerBgVariant: tipo,
				bodyBgVariant: tipo,
				titleClass: tipo,*/
				headerClass: clase + '-header',
				bodyClass: clase + '-body',
				footerClass: clase + '-footer',
				centered: true,
			}).then(value => {
				return value;
			})
				.catch(err => {
					return err;
				})
		} catch (ex) {
			return ex;
		}
	}

	async showConfirm(modal, tipo, titulo, msg, btnOk = 'SI', btnCancel = 'NO') {
		let clase = 'p-2 border-bottom-0 justify-content-center ' + tipo;
		try {
			return modal.msgBoxConfirm(msg, {
				title: titulo,
				size: 'sm',
				buttonSize: 'sm',
				okVariant: tipo,
				okTitle: btnOk,
				cancelTitle: btnCancel,
				headerClass: clase + '-header',
				bodyClass: clase + '-body',
				footerClass: clase + '-footer',
				hideHeaderClose: false,
				centered: true
			})
		} catch (ex) {
			return new Promise;
		}    /*
    return modal.msgBoxConfirm(msg, {
      title: titulo,
      size: 'sm',
      buttonSize: 'sm',
      okVariant: tipo,
      okTitle: btnOk,
      cancelTitle: btnCancel,
      headerClass: clase + '-header',
      bodyClass: clase + '-body',
      footerClass: clase + '-footer',
      hideHeaderClose: false,
      centered: true
    })*/
	}

	async alertForm(modal, tipo, titulo, msg, btnOk = 'SI', btnCancel = 'NO') {
		let clase = 'p-2 border-bottom-0 justify-content-center ' + tipo;
		try {
			return modal.msgBoxConfirm(msg, {
				title: titulo,
				size: 'sm',
				buttonSize: 'sm',
				okVariant: tipo,
				okTitle: btnOk,
				cancelTitle: btnCancel,
				headerClass: clase + '-header',
				bodyClass: clase + '-body',
				footerClass: clase + '-footer',
				hideHeaderClose: false,
				centered: true
			})
		} catch (ex) {
			return new Promise;
		}
	}

	showSuccessToast(mensaje) {
		/*let h = element
		// Create a ID with a incremented count
		const id = 'my-toast-atencion'
		const vNodesMsg = h(
		  'p',
		  { class: ['text-center', 'mb-0'] },
		  [
			h('p',{ class: ['text-center', 'mb-0'] },' Flashy '),
			h('b-button',
			  {
				on: { click: () => this.$bvToast.hide(id) },
				class: ['btn', 'btn-sm']
			  },
			  'Ok'
			),
		  ]*/
		try {
			Vue.swal({
				html: '<span style="color:#155724; font-size: 16px">' + mensaje + '<span>',
				background: "#d4edda",
				iconColor: '#155724',
				position: 'top',
				showConfirmButton: false,
				showCloseButton: true,
				focusConfirm: false,
				backdrop: false,
				allowOutsideClick: true,
				customClass: {
					closeButton: 'swal-cancelar',
					cancelButton: 'swal-cancelar'
				},
				timer: 15000,
				width: "auto",
			});
		} catch (ex) {
			return ex;
		}
		/*
	
		// Create the toast
		this.$bvToast.toast([vNodesMsg], {
		  id: id,
		  title: "Atencion",
		  noCloseButton: true,
		  variant: "danger",
		  solid: true
		})*/
	}
}